export default __webpack_public_path__ + "static/media/lite-logo.5b27143a.png";